import React from 'react';
import {Text, StyleSheet, Dimensions} from 'react-native';
import { COLORS } from 'constants/Colors';
import { Fonts } from 'constants/Fonts';

const WIDTH_OF_DESIGN_SCREEN = 1400

export const PrimaryText = (props) => {

    const {fontSize, fontWeight, style:customStyles, numberOfLines} = props

    const [width, setWidth] = React.useState(Dimensions.get('window').width < 1400 ? Dimensions.get('window').width : 1400);
  
    React.useEffect(() => {
      const handleChange = ({ screen, window: win }) => {
        (win.width>1024 && win.width<1400) && setWidth(win.width);
      };
  
      const subscription = Dimensions.addEventListener('change', handleChange);
      return () => {
        subscription.remove();
      };
    }, [setWidth]);

    let style = styles(fontSize, fontWeight, width)
    return (
        <Text 
        style={[style.title, customStyles]} 
        numberOfLines={numberOfLines ? numberOfLines : 0}
        >{props.children}</Text>
    );
};

const styles = (fontSize, fontWeight, screenWidth) => StyleSheet.create({
    title: {
        fontSize: fontSize/WIDTH_OF_DESIGN_SCREEN*screenWidth,
        lineHeight: fontSize/WIDTH_OF_DESIGN_SCREEN*screenWidth*1.25,
        color: COLORS.primary.darkBlue,
        fontFamily: 'Moranga',
        fontWeight: fontWeight,
        textAlign: 'left',
    }
});

const getFontWeight = (fontWeight) => {
    switch (fontWeight) {
        case 100:
            return Fonts.primary.extraLight
        case 200:
            return Fonts.primary.light
        case 300:
            return Fonts.primary.regular
        case 400:
            return Fonts.primary.medium
        case 500:
            return Fonts.primary.semiBold
        case 600:
            return Fonts.primary.semiBold
        case 700:
            return Fonts.primary.bold
        case 800:
            return Fonts.primary.extraBold
        default:
            return Fonts.primary.regular
    }
}
